import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { pixelRatio2d } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { IShapePoint2d } from '@/editor/types/shape';
import { Path, Shape } from 'three';
import { isArc } from '../arc';

export function pathToGmtShape(path: IShapePoint2d[], holes: IShapePoint2d[][] = []) {
  const shape = new Shape();

  if (!path.length) return shape;

  const len = path.length;
  shape.moveTo(path[0].x / pixelRatio2d, path[0].y / pixelRatio2d);
  for (let i = 0; i < len; i++) {
    const p1 = path[i];
    const p2 = path[(i + 1) % len];

    // 弧墙处理
    if (isArc(p1)) {
      const arc = new ArcSeg2d({ start: p1, end: p2, center: p1.center, clockwise: p1.clockwise });
      shape.absarc(
        arc.center.x / pixelRatio2d,
        arc.center.y / pixelRatio2d,
        arc.radius / pixelRatio2d,
        arc.startAngle,
        arc.endAngle,
        arc.clockwise
      );
    } else {
      shape.lineTo(p2.x / pixelRatio2d, p2.y / pixelRatio2d);
    }
  }

  for (const hole of holes) {
    if (!hole.length) continue;

    const holePath = new Path();
    holePath.moveTo(hole[0].x / pixelRatio2d, hole[0].y / pixelRatio2d);

    for (let i = 0; i < hole.length; i++) {
      const p1 = hole[i % hole.length];
      const p2 = hole[(i + 1) % hole.length];

      if (isArc(p1)) {
        const arc = new ArcSeg2d({ start: p1, end: p2, center: p1.center, clockwise: p1.clockwise });
        holePath.absarc(
          arc.center.x / pixelRatio2d,
          arc.center.y / pixelRatio2d,
          arc.radius / pixelRatio2d,
          arc.startAngle,
          arc.endAngle,
          arc.clockwise
        );
      } else {
        holePath.lineTo(p2.x / pixelRatio2d, p2.y / pixelRatio2d);
      }
    }
    shape.holes.push(holePath);
  }

  return shape;
}

// 离散化路径，主要针对弧形路径
export function dispersePath(path: IShapePoint2d[]): IPoint2d[] {
  if (path.every((p) => !p.center)) {
    // 不包含圆弧，直接返回
    return path;
  }

  const len = path.length;
  const points = [path[0]];
  for (let i = 0; i < len; i++) {
    const p1 = path[i];
    const p2 = path[(i + 1) % len];

    // 弧墙处理
    if (isArc(p1)) {
      const arc = new ArcSeg2d({ start: p1, end: p2, center: p1.center, clockwise: p1.clockwise });
      points.push(...arc.getPoints());
    } else {
      points.push(p2);
    }
  }

  return points;
}
